/**
 * useCancelFeesData — l'aperçu des frais (étape 3).
 *
 * `GET /api/v1/subscription/cancellation-fees` au montage, sans paramètre, comme
 * `CancelFeesScreen.js:74-86`. La réponse n'a aucun cas SUCCESS de réducteur : elle reste ici
 * (patron B) et part au view-model.
 *
 * La garde `awaiting` de `useApiFetch` compte ici : l'étape 4 interroge **la même** tranche pour
 * relire la carte (`CancelPaymentScreen.js:218-222`) alors que l'étape 3 est toujours montée
 * dessous — sans elle, un aperçu demandé par l'étape 4 viendrait repeindre l'étape 3.
 */
import { subscriptionService } from "../../../../../../data/services/subscriptionService"
import { type ApiCancellationFees } from "../../../../adapters/parent/SubscriptionCancel/subscriptionCancelAdapter"
import { useApiFetch } from "../../../hooks/useApiFetch"

export function useCancelFeesData() {
    const { raw, loading, fetch } = useApiFetch<ApiCancellationFees>({
        service: subscriptionService.getCancellationFees,
    })

    return { raw, loading, retry: fetch }
}
